export const semesters = [
  { label: "1er - 3er año", value: "1" },
  { label: "4to - 6to año", value: "2" },
  { label: "Interno", value: "3" },
  { label: "Médico egresado", value: "4" },
];
